<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="modelsCreate">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-overlay
              :show="loading"
              rounded
              opacity="0.5"
              spinner-small
              spinner-variant="primary"
            >
              <b-form-group
                label="Hardware"
                label-class="label-class"
                class="neighbouring-form-group m-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="select_hardware"
                >
                  <v-select
                    v-model="activeSelectedHardware"
                    :options="portsSlots"
                    placeholder="Selected hardware"
                    :reduce="option => option.id"
                    label="name"
                    :disabled="form.is_default"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div :style="{ display: isPortsStatsAvailable ? 'block' : 'none' }">

                <hardware-stats
                  v-if="!loading"
                  :ports="portsSlots"
                  :active-selected-hardware="activeSelectedHardware"
                  :site-prop="siteId"
                  :hide-actions="true"
                />
              </div>
            </b-overlay>
            <b-overlay
              :show="loading"
              rounded
              opacity="0.5"
              spinner-small
              spinner-variant="primary"
              class="p-2"
            >
              <div class="section-block mb-4">
                <div class="section-block__title">
                  <feather-icon
                    icon="GlobeIcon"
                    width="24"
                    height="24"
                  />
                  <h2>{{ form.is_default ? 'Vlan Ports' : 'Ports' }}</h2>
                </div>
                <b-form-group
                  label="Select Vlan Network"
                  label-class="label-class"
                  class="neighbouring-form-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="select_hardware"
                  >
                    <v-select
                      v-model="selectedVlan"
                      :options="sitesLans"
                      placeholder="Selected vlan network"
                      label="name"
                      :disabled="form.is_default"
                      @search="handleChangeHardware($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label="Tagged ports"
                  label-class="label-class"
                  class="neighbouring-form-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="tagged_ports"
                  >
                    <multiselect
                      v-model="tagged_ports"
                      :options="portsOption"
                      :disabled="selectedVlan ? selectedVlan.is_default : false"
                      multiple
                      placeholder="Select tagged ports"
                      class="multiselect with-remove"
                      :searchable="false"
                      label="fullName"
                      @select="(prop) => onSelectPort(prop, 'tagged')"
                      @remove="(prop) => onDeselectPort(prop, 'tagged')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div class="all-buttons-container">
                  <b-button
                    v-if="portsOption.length > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    :disabled="selectedVlan ? selectedVlan.is_default : false"
                    @click="handleAttachAvailableTo('tagged')"
                  >
                    Select All
                  </b-button>
                  <b-button
                    v-if="tagged_ports.length > 0"
                    type="button"
                    :disabled="selectedVlan ? selectedVlan.is_default : false"
                    @click="onDeselectPortArray('tagged')"
                  >
                    Deselect All
                  </b-button>
                </div>
                <b-form-group
                  label="Untagged ports"
                  label-class="label-class"
                  class="neighbouring-form-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="untagged_ports"
                  >
                    <multiselect
                      v-model="untagged_ports"
                      :options="portsOption"
                      :disabled="selectedVlan ? selectedVlan.is_default : false"
                      multiple
                      placeholder="Select tagged ports"
                      class="multiselect with-remove"
                      :searchable="false"
                      label="fullName"
                      @select="(prop) => onSelectPort(prop, 'untagged')"
                      @remove="(prop) => onDeselectPort(prop, 'untagged')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div class="all-buttons-container">
                  <b-button
                    v-if="portsOption.length > 0"
                    type="button"
                    :disabled="selectedVlan ? selectedVlan.is_default : false"
                    @click="handleAttachAvailableTo('untagged')"
                  >
                    Select All
                  </b-button>
                  <b-button
                    v-if="untagged_ports.length > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    :disabled="selectedVlan ? selectedVlan.is_default : false"
                    @click="onDeselectPortArray('untagged')"
                  >
                    Deselect All
                  </b-button>
                </div>
                <p
                  v-if="selectedVlan ? selectedVlan.is_default : false"
                  class="lan-error-message"
                >
                  Edit is not allowed for dynamic ports
                </p>
              </div>
            </b-overlay>
            <!-- submit button -->
            <b-col
              cols="12"
              class="text-right buttons-container__left"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                ok-variant="secondary"
                @click.prevent="goBack"
              >
                Cancel
              </b-button>
              <b-button-request
                text="Update"
                :request="validationForm"
              />
            </b-col>
          </b-col></b-row>
      </b-form>
    </validation-observer>
    <b-modal
      id="savedLan"
      ref="savedLan"
      title="Success!"
      size="md"
      ok-title="Continue"
      cancel-title="Close"
      centered
      @hidden="goContinue"
      @ok="goContinue"
      @cancel="goBack"
    >
      <p>Changes have been applied successfully.</p>
    </b-modal>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup, BForm, BRow, BCol, BButton, BCard,
  BOverlay,
} from 'bootstrap-vue'
import { required, max } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import axios from '../../axios-resolver'
import BButtonRequest from '../../../../components/BButtonRequest.vue'
import HardwareStats from '../../hardware/HardwareStats.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButtonRequest,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    Multiselect,
    BOverlay,
    vSelect,
    HardwareStats,
  },
  data() {
    return {
      siteId: this.$route.query.site,
      networkId: this.$route.query.network,
      hardwareId: this.$route.query.hardware,
      form: {
        name: '',
        vlan_id: '',
        interface_ip: '',
        subnet_mask: '',
        comment: '',
      },
      isPortsStatsAvailable: false,
      sitesLans: [],
      selectedVlan: '',
      portsOption: [],
      portsOrigin: [],
      activeSiteHardwareStats: null,
      sitesHardwares: [],

      tagged_ports: [], // should get its value on current active hardware when a all_tagged_ports is changed (no direct mutation)
      untagged_ports: [], // should get its value on current active hardware when a all_untagged_ports is changed (no direct mutation)

      all_tagged_ports: {}, // {[id_hardware]: [ports]}
      all_untagged_ports: {}, // {[id_hardware]: [ports]}

      portsSlots: [],
      activeSelectedHardware: null,

      loading: true,

      payloadSaveData: {
        name: '',
        vlan_id: '',
        interface_ip: '',
        subnet_mask: '',
        comment: '',
      },

      required,
      max,
    }
  },
  watch: {
    selectedVlan() {
      if (this.selectedVlan !== this.$route.query.network) {
        let netId = this.selectedVlan
        if (this.selectedVlan?.id) {
          netId = this.selectedVlan.id
        }
        this.networkId = netId

        this.$router.replace({
          query: {
            ...this.$route.query,
            network: netId,
          },
        })
        this.fetchTaggedUntaggedPortsHardware(netId)
      }
    },
    activeSelectedHardware() {
      const hardware = this.portsSlots.find(hardwareProp => hardwareProp.id === this.activeSelectedHardware)
      // get ports options from the selected hardware
      this.portsOption = this.portsSlots.find(hardwareProp => hardwareProp.id === this.activeSelectedHardware).ports

      // update tagged and untagged ports
      this.tagged_ports = this.all_tagged_ports[this.activeSelectedHardware] || []
      this.untagged_ports = this.all_untagged_ports[this.activeSelectedHardware] || []

      // filter portOption from tagged and untagged ports
      this.portsOption = this.portsOption.filter(port => {
        const tagged = this.tagged_ports.find(taggedPort => taggedPort.id === port.id)
        const untagged = this.untagged_ports.find(untaggedPort => untaggedPort.id === port.id)

        return !tagged && !untagged
      })

      this.isPortsStatsAvailable = hardware.type === 'switch' || hardware.type.includes('controller')

      this.$router.replace({
        query: {
          ...this.$route.query,
          hardware: this.activeSelectedHardware,
        },
      })
      this.hardwareId = this.activeSelectedHardware
    },
    all_tagged_ports() {
      this.tagged_ports = this.all_tagged_ports[this.activeSelectedHardware] || []
    },
    all_untagged_ports() {
      this.untagged_ports = this.all_untagged_ports[this.activeSelectedHardware] || []
    },
  },
  destroyed() {
    document.querySelector('.content-header-title__extra-info').innerHTML = ''
  },
  async created() {
    Promise.all([
      this.fetchSitesLAN(),
      this.fetchTaggedUntaggedPortsHardware(),
    ]).then(() => {
      this.loading = false
    })
  },
  methods: {
    async setSiteName(id) {
      try {
        if (id) {
          const pageTitle = document.querySelector('.content-header-title__extra-info')
          // create link to the site and put it in the title

          const { data: { data } } = await axios.get(`/site/${id}/show`)

          const link = document.createElement('a')
          link.href = `/site/${id}/hardware/index`
          link.innerHTML = `(${data.name})`

          pageTitle.innerHTML = ''
          pageTitle.appendChild(link)
        }

        this.isAccessPointUnlicensed = this.summary.isAccessPointUnlicensed // do when the API will be ready
      } catch (error) {
        console.log('error', error)
      }
    },
    handleChangeHardware(vlan) {
      this.portsOption = vlan.ports
    },
    handleAttachAvailableTo(type) {
      // all_ update only available ports
      if (type === 'tagged') {
        this.all_tagged_ports = {
          ...this.all_tagged_ports,
          [this.activeSelectedHardware]: [
            ...this.all_tagged_ports[this.activeSelectedHardware],
            ...this.portsOption,
          ],
        }
      } else {
        this.all_untagged_ports = {
          ...this.all_untagged_ports,
          [this.activeSelectedHardware]: [
            ...this.all_untagged_ports[this.activeSelectedHardware],
            ...this.portsOption,
          ],
        }
      }

      // update options
      this.portsOption = []
    },
    onSelectPort(prop, type = 'tagged') {
      // all_ update
      if (type === 'tagged') {
        if (!this.all_tagged_ports[this.activeSelectedHardware]) {
          this.all_tagged_ports = {
            ...this.all_tagged_ports,
            [this.activeSelectedHardware]: [prop],
          }
        } else {
          this.all_tagged_ports = {
            ...this.all_tagged_ports,
            [this.activeSelectedHardware]: [
              ...this.all_tagged_ports[this.activeSelectedHardware],
              prop,
            ],
          }
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (!this.all_untagged_ports[this.activeSelectedHardware]) {
          this.all_untagged_ports = {
            ...this.all_untagged_ports,
            [this.activeSelectedHardware]: [prop],
          }
        } else {
          this.all_untagged_ports = {
            ...this.all_untagged_ports,
            [this.activeSelectedHardware]: [
              ...this.all_untagged_ports[this.activeSelectedHardware],
              prop,
            ],
          }
        }
      }

      // clear from options
      this.portsOption = this.portsOption.filter(port => port.id !== prop.id)
    },
    onDeselectPort(prop, type) {
      // all_ update
      // revert to onSelectPort
      if (type === 'tagged') {
        this.all_tagged_ports = {
          ...this.all_tagged_ports,
          [this.activeSelectedHardware]: this.all_tagged_ports[this.activeSelectedHardware].filter(port => port.id !== prop.id),
        }
      } else {
        this.all_untagged_ports = {
          ...this.all_untagged_ports,
          [this.activeSelectedHardware]: this.all_untagged_ports[this.activeSelectedHardware].filter(port => port.id !== prop.id),
        }
      }

      // return to options
      this.portsOption = [
        ...this.portsOption,
        prop,
      ]
    },
    onDeselectPortArray(type) {
      // all_ update
      if (type === 'tagged') {
        this.all_tagged_ports = {
          ...this.all_tagged_ports,
          [this.activeSelectedHardware]: [],
        }
      } else {
        this.all_untagged_ports = {
          ...this.all_untagged_ports,
          [this.activeSelectedHardware]: [],
        }
      }
      // update options
      this.portsOption = [
        ...this.portsOption,
        ...(type === 'tagged' ? this.tagged_ports : this.untagged_ports),
      ]
    },
    goBack() {
      this.$router.go(-1)
    },
    goContinue() {
      this.$refs.savedLan.hide()
    },
    async fetchSiteHardwares() {
      try {
        const { data } = await axios.get(`/site/${this.siteId}/hardware/index`)
        // filter, only switcher are allowed hardware.model.type === 'switch'
        this.sitesHardwares = data.data.filter(hardware => hardware.model.type.id === 'switch')
      } catch (err) {
        console.warn(err)

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async fetchSitesLAN() {
      try {
        const { data } = await axios.get(`/site/${this.siteId}/network/setting/lan/index`)
        this.sitesLans = data.data

        // find as the same as networkId and set it there
        this.selectedVlan = this.sitesLans.find(lan => lan.id === +this.networkId)
      } catch (err) {
        console.warn(err)
      }
    },
    async fetchTaggedUntaggedPortsHardware() {
      let portsSlotsRaw = []
      try {
        const { data } = await axios.get(`/site/${this.siteId}/controller`)
        const { controller, switches } = data.data
        portsSlotsRaw = [{
          name: controller.name,
          id: controller.id,
          ports: controller.model.ports.map(port => ({
            ...port,
            fullName: `${port.interface} - ${port.usage}`,
          })),
          type: 'controller',
        }]

        if (switches) {
          switches.forEach(switchItem => {
            portsSlotsRaw.push({
              name: switchItem.name,
              id: switchItem.id,
              ports: switchItem.model.ports.map(port => ({
                ...port,
                fullName: `${port.interface} - ${port.usage}`,
              })),
              type: 'switch',
            })
          })
        }

        if (this.loading) {
        // of every existing hardware create keys for all_tagged_ports and all_untagged_ports
          portsSlotsRaw.forEach(hardware => {
            this.all_tagged_ports = {
              ...this.all_tagged_ports,
              [hardware.id]: [],
            }
            this.all_untagged_ports = {
              ...this.all_untagged_ports,
              [hardware.id]: [],
            }
          })
        }

        const hardwarePorts = portsSlotsRaw.find(hardware => hardware.id === +this.hardwareId)

        if (hardwarePorts) {
          this.portsOrigin = hardwarePorts.ports.flat()
          this.portsOption = hardwarePorts.ports.flat()
        }
        this.portsSlots = portsSlotsRaw

        // eslint-disable-next-line prefer-destructuring
        // if (!this.activeSelectedHardware) {
        //   this.activeSelectedHardware = portsSlotsRaw[0].id
        // }
        this.setSiteName(this.siteId)
      } catch (err) {
        console.warn(err)
      }
      if (this.networkId) {
        try {
          const { data } = await axios.get(`/site/${this.siteId}/network/setting/lan/${this.networkId}`)
          this.payloadSaveData = {
            ...data.data,
          }

          // tagged_ports and untagged_ports is for controller

          // switches ports array contains keys of the switcher

          if (data.data.switches_ports) {
            // handle switches and controller tagged and untagged ports and update options, get info about ports and controllers from portsOrigin and portsSlots
            Object.keys(data.data.switches_ports).forEach(switchId => {
              const { tagged, untagged } = data.data.switches_ports[switchId]

              this.all_tagged_ports = {
                ...this.all_tagged_ports,
                [switchId]: tagged.map(port => {
                  const hardwarePorts = this.portsSlots.find(hardware => hardware.id === Number(switchId))

                  if (!hardwarePorts) return null
                  return hardwarePorts.ports.find(originPort => originPort.id === port.id)
                }),
              }
              this.all_untagged_ports = {
                ...this.all_untagged_ports,
                [switchId]: untagged.map(port => {
                  const hardwarePorts = this.portsSlots.find(hardware => hardware.id === Number(switchId))

                  if (!hardwarePorts) return null
                  return hardwarePorts.ports.find(originPort => originPort.id === port.id)
                }),
              }
            })
          }

          this.all_tagged_ports = {
            ...this.all_tagged_ports,
            [this.portsSlots[0].id]: data.data.tagged_ports ? data.data.tagged_ports.map(port => {
              const hardwarePorts = this.portsSlots.find(hardware => hardware.id === this.portsSlots[0].id)

              if (!hardwarePorts) return null
              return hardwarePorts.ports.find(originPort => originPort.id === port.id)
            }) : [],
          }

          this.all_untagged_ports = {
            ...this.all_untagged_ports,
            [this.portsSlots[0].id]: data.data.untagged_ports ? data.data.untagged_ports.map(port => {
              const hardwarePorts = this.portsSlots.find(hardware => hardware.id === this.portsSlots[0].id)

              if (!hardwarePorts) return null
              return hardwarePorts.ports.find(originPort => originPort.id === port.id)
            }) : [],
          }
          const selectedHardware = this.hardwareId || portsSlotsRaw[0].id

          this.tagged_ports = this.all_tagged_ports[selectedHardware] || []
          this.untagged_ports = this.all_untagged_ports[selectedHardware] || []

          // filter portOption from tagged and untagged ports
          this.portsOption = this.portsOption.filter(port => {
            const tagged = this.tagged_ports.find(taggedPort => taggedPort.id === port.id)
            const untagged = this.untagged_ports.find(untaggedPort => untaggedPort.id === port.id)

            return !tagged && !untagged
          })

          this.activeSelectedHardware = portsSlotsRaw.find(hardware => hardware.id === Number(selectedHardware)).id
        } catch (err) {
          console.warn(err)
        }
      } else if (this.hardwareId) {
        const selectedHardware = this.hardwareId || portsSlotsRaw[0].id
        this.activeSelectedHardware = portsSlotsRaw.find(hardware => hardware.id === Number(selectedHardware)).id
      }
    },
    async validationForm() {
      const valid = await this.$refs.modelsCreate.validate()

      if (valid) {
        try {
          const controllerPorts = {
            tagged: this.all_tagged_ports[this.portsSlots[0].id].map(port => port.id),
            untagged: this.all_untagged_ports[this.portsSlots[0].id].map(port => port.id),
          }

          const switchesPorts = this.portsSlots.slice(1).reduce((acc, switchItem) => {
            acc[switchItem.id] = {
              tagged: this.all_tagged_ports[switchItem.id].map(port => port.id),
              untagged: this.all_untagged_ports[switchItem.id].map(port => port.id),
            }

            return acc
          }, {})
          const payload = {
            name: this.payloadSaveData.name,
            vlan_id: this.payloadSaveData.vlan_id,
            interface_ip: this.payloadSaveData.interface_ip,
            subnet_mask: this.payloadSaveData.subnet_mask,
            comment: this.payloadSaveData.comment,
            controller_ports: controllerPorts,
            switches_ports: switchesPorts,
          }
          await axios.put(`site/${this.siteId}/network/setting/lan/${this.networkId}/${this.activeSelectedHardware}`, payload)

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success!',
              icon: 'BellIcon',
              variant: 'success',
            },
          })

          this.$refs.savedLan.show()
        } catch (error) {
          console.warn('error', error)
          const { status } = error.response

          if (status === 422) {
            const { fields } = error.response.data

            const untaggedPorts = Object.keys(fields).filter(field => field.startsWith('untagged_ports'))
            const taggedPorts = Object.keys(fields).filter(field => field.startsWith('tagged_ports'))

            const errors = {
              ...fields,
              untagged_ports: untaggedPorts.map(port => fields[port])[0],
              tagged_ports: taggedPorts.map(port => fields[port])[0],
            }

            this.$refs.modelsCreate.setErrors(errors)
          }
        }
      }
    },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.lan-error-message {
  font-size: 14px;
  color: rgb(237, 122, 122);
}
.hardware-stats-info {
  margin-bottom: 0 !important;
}

.hardware-stats-layout {
  margin-bottom: 0 !important;
}
</style>
